module.exports = __webpack_public_path__ + "img/chev_down_blue.1ab9db76.svg";